module.exports = __webpack_public_path__ + "static/media/lumbering32.1690c365.jpg";